import * as React from "react"

const Logotype = (props: React.SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 546 528" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path d="M439.7 438.74C497.11 401.23 532.32 332.34 532.32 255.8C532.32 118.02 426.69 0.130005 266.71 0.130005C104.43 0.130005 0.329956 122.61 0.329956 264.98C0.329956 408.12 106.73 527.53 265.95 527.53H545.34V441.03H439.7V438.74ZM265.95 437.98C160.32 437.98 93.72 356.84 93.72 264.22C93.72 170.07 161.08 89.7 265.95 89.7C371.58 89.7 439.71 170.07 439.71 264.22C439.7 356.84 372.34 437.98 265.95 437.98Z" fill="currentColor"/>
  </svg>
)

export default Logotype;
